import React from "react";
import Routes from "./routes";

const App = () => {
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
};

export default App;
